export default __webpack_public_path__ + "static/media/ram-tracking.19feb8e4.png";